import { useQuery } from 'data-fetching-client';
import get from 'hs-lodash/get';
import { Map as ImmutableMap } from 'immutable';
import * as SourceApps from 'automation-ui-source-apps/constants/SourceApps';
import { GET_ACCESS_BY_OBJECT_TYPE_ID } from 'automation-ui-action-features/access/accessQueries';
import { jsx as _jsx } from "react/jsx-runtime";
const UNKNOWN_OBJECT_TYPE_ID = '0-0';
const getObjectTypeId = props => props.objectTypeId || props.flowObjectTypeId || UNKNOWN_OBJECT_TYPE_ID;
const getFlowSourceApp = props => props.flowSourceApp || props.sourceApp || props.sourceAppId || SourceApps.WORKFLOWS_APP;
export const useAccessByEnrolledType = (enrolledType, flowSourceApp = SourceApps.WORKFLOWS_APP) => {
  var _data$accessByObjectT, _data$accessByObjectT2;
  const {
    data,
    error,
    loading
  } = useQuery(GET_ACCESS_BY_OBJECT_TYPE_ID, {
    variables: {
      flowSourceApp
    }
  });
  const accessByEnrolledType = (_data$accessByObjectT = data === null || data === void 0 || (_data$accessByObjectT2 = data.accessByObjectTypeId) === null || _data$accessByObjectT2 === void 0 ? void 0 : _data$accessByObjectT2.objectTypeAccessByEnrolledType) !== null && _data$accessByObjectT !== void 0 ? _data$accessByObjectT : {};
  let access;
  if (enrolledType.type === 'CRM_OBJECT') {
    var _accessByEnrolledType;
    access = loading ? null : (_accessByEnrolledType = accessByEnrolledType['CRM_OBJECT']) === null || _accessByEnrolledType === void 0 ? void 0 : _accessByEnrolledType[enrolledType.objectTypeId];
  } else if (enrolledType.type === 'DATASET') {
    var _accessByEnrolledType2;
    access = loading ? null : (_accessByEnrolledType2 = accessByEnrolledType['DATASET']) === null || _accessByEnrolledType2 === void 0 ? void 0 : _accessByEnrolledType2[enrolledType.datasetId];
  } else {
    access = accessByEnrolledType[enrolledType.type];
  }
  if (!access) {
    var _accessByEnrolledType3;
    access = (_accessByEnrolledType3 = accessByEnrolledType['CRM_OBJECT']) === null || _accessByEnrolledType3 === void 0 ? void 0 : _accessByEnrolledType3[UNKNOWN_OBJECT_TYPE_ID];
  }
  return {
    access,
    accessError: error,
    accessIsLoading: loading
  };
};
export const useAccessByObjectTypeId = (objectTypeId, flowSourceApp = SourceApps.WORKFLOWS_APP) => {
  var _data$accessByObjectT3, _data$accessByObjectT4;
  const {
    data,
    error,
    loading
  } = useQuery(GET_ACCESS_BY_OBJECT_TYPE_ID, {
    variables: {
      flowSourceApp
    }
  });
  const accessByObjectType = (_data$accessByObjectT3 = data === null || data === void 0 || (_data$accessByObjectT4 = data.accessByObjectTypeId) === null || _data$accessByObjectT4 === void 0 ? void 0 : _data$accessByObjectT4.objectTypeAccessById) !== null && _data$accessByObjectT3 !== void 0 ? _data$accessByObjectT3 : {};
  let access = loading ? null : accessByObjectType[objectTypeId];

  // certain objectTypeIds, such as custom objects, don't have an access entry
  if (!access) {
    access = accessByObjectType[UNKNOWN_OBJECT_TYPE_ID];
  }
  return {
    access,
    accessError: error,
    accessIsLoading: loading
  };
};
export const wireAllAccessByObjectTypeId = WrappedComponent => props => {
  const flowSourceApp = getFlowSourceApp(props);
  const {
    data,
    error,
    loading
  } = useQuery(GET_ACCESS_BY_OBJECT_TYPE_ID, {
    variables: {
      flowSourceApp
    }
  });
  const allAccessByObjectType = !loading ? ImmutableMap(get(data, 'accessByObjectTypeId.objectTypeAccessById', {})) : ImmutableMap();
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    allAccess: allAccessByObjectType,
    allAccessError: error,
    allAccessIsLoading: loading
  }));
};
export const wireAccessByObjectTypeId = WrappedComponent => props => {
  const accessObjectTypeId = getObjectTypeId(props);
  const flowSourceApp = getFlowSourceApp(props);
  const {
    access,
    accessError,
    accessIsLoading
  } = useAccessByObjectTypeId(accessObjectTypeId, flowSourceApp);
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
    access: access,
    accessError: accessError,
    accessIsLoading: accessIsLoading
  }));
};